/**
 * Image assets for Animal Emergency Rescue Platform
 */
export const images = {
  hero: 'https://images.unsplash.com/photo-1450778869180-41d0601e046e?auto=format&fit=crop&w=2000&q=80',
  reporterBanner: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=800&q=80',
  volunteerBanner: 'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?auto=format&fit=crop&w=800&q=80',
  volunteerBannerFallback: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?auto=format&fit=crop&w=800&q=80',
  mapPin: 'https://cdn-icons-png.flaticon.com/512/684/684908.png',
};
